type ViewConfig = {
  viewName: string;
  viewVariation: string;
  byField: string;
  list?: any;
  calendar?: any;
  kanban?: any;
  timeline?: any;
  img?:string;
};

export function generateApplicableViews(fields: any[]): ViewConfig[] {
  const result: ViewConfig[] = [];
  const seenVariations = new Set<string>();
  let hasList = false;

  const normalizedType = (type: string): string =>
    type?.toLowerCase().replace(/\s/g, "");
    let  calendarField;
  for (const field of fields) {
    const type = normalizedType(field.type || "");
    const isDim = field.isDimensional === true;
    const fieldType = field.fieldType?.toUpperCase();
    const isKanBanfield =
      fieldType === "ENTITY" || fieldType === "DYNAMICLOOKUP" ? true : false;
    const fieldName = field.name;

    if (!fieldName) continue;

    if (isDim && (type === "date" || type === "datetime")) {
      const exists = result.some((item) => item.viewName === "Calendar");
      if (!exists){
        calendarField = fieldName;
        result.push({
          viewName: "Calendar",
          viewVariation: `Calendar-${fieldName}`,
          byField: fieldName,
          calendar:[],
          img:"Calendar.png"
        });}else{
           result.find((item) => item.viewName === "Calendar").calendar.push(fieldName);
        }
      const existsTL = result.some((item) => item.viewName === "Timeline");
      if (!existsTL) {
        result.push({
          viewName: "Timeline",
          viewVariation: `Timeline-${fieldName}`,
          byField: fieldName,
          timeline: [],
           img:"Timeline.png"
        });
      }else{
         result.find((item) => item.viewName === "Timeline").timeline.push(fieldName);
      }
    } else if (isKanBanfield) {
      const exists = result.some((item) => item.viewName === "Kanban");
      if (!exists) {
        result.push({
          viewName: "Kanban",
          viewVariation: `Kanban-${fieldName}`,
          byField: fieldName,
          kanban: [],
             img:"Kanban.png"
        });
      } else {
          result.find((item) => item.viewName === "Kanban").kanban.push(fieldName);
    
      }
    }
  }
 result.push({
      viewName: "Tabular",
      viewVariation: "Tabular",
      byField: "Default",
        img:"List.png"
    });
    
  if (fields.length > 6) {
    result.push({
      viewName: "List",
      viewVariation: "List-Default",
      byField: "Default",
        img:"List.png"
    });
  }

    result.push({
      viewName: "Card",
      viewVariation: "simpleCardDesign",
      byField: "Default",
        img:"Card.png"
    });
    result.push({
      viewName: "AllView",
      viewVariation: "AllView",
      byField: calendarField,
       img:"AllView.png"
    });
  // Deduplicate by viewName and viewVariation
  return result.filter((entry) => {
    const key = `${entry.viewName}-${entry.viewVariation}`;
    if (seenVariations.has(key)) return false;
    seenVariations.add(key);
    return true;
  });
}

const sampleOutput = [
  {
    viewName: "Calendar",
    viewVariation: "Calendar-START_DATE",
    byField: "START_DATE",
  },
  {
    viewName: "Timeline",
    viewVariation: "Timeline-START_DATE",
    byField: "START_DATE",
  },
  {
    viewName: "Kanban",
    viewVariation: "Kanban-STATUS",
    byField: "STATUS",
  },
  {
    viewName: "Kanban",
    viewVariation: "Kanban-All",
    byField: "AllFields",
  },
  {
    viewName: "List",
    viewVariation: "List-Default",
    byField: "Default",
  },
];
